import lodash from "lodash";
export var Towers;
(function (Towers) {
    Towers.towers = [1, 2, 3, 4, 5];
    let Street;
    (function (Street) {
        let _all = null;
        function empty() { return [null, null, null, null, null]; }
        Street.empty = empty;
        function all() {
            if (!_all) {
                _all = (() => {
                    function all_permutations(elements) {
                        if (elements.length == 0)
                            return [[]];
                        return elements.flatMap((next, i) => all_permutations(elements.filter((e, idx) => idx != i)).map(perm => [next, ...perm]));
                    }
                    return all_permutations([1, 2, 3, 4, 5]);
                })();
            }
            return _all;
        }
        Street.all = all;
        function line_of_sight(street) {
            let n = 0;
            let highest = 0;
            for (let i = 0; i < street.length; i++) {
                if (street[i] > highest) {
                    n++;
                    highest = street[i];
                }
            }
            return n;
        }
        function reverse(street) {
            return street.slice().reverse();
        }
        Street.reverse = reverse;
        function label(street) {
            return [line_of_sight(street), line_of_sight(reverse(street))];
        }
        Street.label = label;
    })(Street = Towers.Street || (Towers.Street = {}));
    let LabelledStreet;
    (function (LabelledStreet) {
        let _all = null;
        function all() {
            if (!_all)
                _all = Street.all().map(street => ({ street, label: Street.label(street) }));
            return _all;
        }
        LabelledStreet.all = all;
    })(LabelledStreet = Towers.LabelledStreet || (Towers.LabelledStreet = {}));
    let LabelPair;
    (function (LabelPair) {
        function equals(a, b) {
            return a[0] == b[0] && a[1] == b[1];
        }
        LabelPair.equals = equals;
        let _candidates = null;
        function candidateMap() {
            return Towers.towers.map(a => Towers.towers.map(b => LabelledStreet.all().filter(l => LabelPair.equals([a, b], l.label)).map(i => i.street)));
        }
        LabelPair.candidateMap = candidateMap;
        function getCandidates(label) {
            if (!_candidates) {
                _candidates = candidateMap();
            }
            return _candidates[label[0] - 1][label[1] - 1];
        }
        LabelPair.getCandidates = getCandidates;
    })(LabelPair = Towers.LabelPair || (Towers.LabelPair = {}));
    let Hints;
    (function (Hints) {
        function empty() {
            return {
                top: [null, null, null, null, null],
                bottom: [null, null, null, null, null],
                left: [null, null, null, null, null],
                right: [null, null, null, null, null],
            };
        }
        Hints.empty = empty;
    })(Hints = Towers.Hints || (Towers.Hints = {}));
    let Blocks;
    (function (Blocks) {
        function empty() {
            return {
                rows: [Street.empty(), Street.empty(), Street.empty(), Street.empty(), Street.empty()]
            };
        }
        Blocks.empty = empty;
        function combine(a, b) {
            return {
                rows: a.rows.map((row, y) => row.map((tile, x) => tile ?? b.rows[y][x]))
            };
        }
        Blocks.combine = combine;
    })(Blocks = Towers.Blocks || (Towers.Blocks = {}));
    let Puzzle;
    (function (Puzzle) {
        function col(matrix, i) {
            return matrix.map(row => row[i]);
        }
        function solve(puzzle) {
            function valid(rows, column_hints) {
                const row_count = rows.length;
                // Check for duplicates.
                // Only compare with last row because it's the only one that changed since the last step
                for (let i = 0; i < 5; i++) {
                    for (let j = 0; j < row_count - 1; j++) {
                        if (rows[j][i] == rows[row_count - 1][i])
                            return false;
                    }
                }
                if (rows.length == 5) {
                    if (![0, 1, 2, 3, 4].every(i => LabelPair.equals(Street.label(col(rows, i)), column_hints[i])))
                        return false;
                }
                return true;
            }
            function backtrack(hints, streets_so_far) {
                if (!valid(streets_so_far, puzzle.columns))
                    return null;
                if (hints.length == 0)
                    return { rows: streets_so_far };
                for (const candidate of LabelPair.getCandidates(hints[0])) {
                    const res = backtrack(hints.slice(1), [...streets_so_far, candidate]);
                    if (res)
                        return res;
                }
                return null;
            }
            return backtrack(puzzle.rows, []);
        }
        Puzzle.solve = solve;
    })(Puzzle = Towers.Puzzle || (Towers.Puzzle = {}));
    function solve(hints) {
        const pairs = {
            columns: lodash.zip(hints.top, hints.bottom).map(([top, bottom]) => [top, bottom]),
            rows: lodash.zip(hints.left, hints.right).map(([top, bottom]) => [top, bottom])
        };
        const res = Puzzle.solve(pairs);
        if (res)
            return {
                hints: hints,
                blocks: Puzzle.solve(pairs)
            };
        else
            return null;
    }
    Towers.solve = solve;
})(Towers || (Towers = {}));
